import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'
import { Modal } from '../../../components/Modal/Modal'
import { useDeleteEmailTypeMutation } from '../../../store/integrations/emailTypes'
import { EmailType } from '../../../models/EmailType'

export interface UninstallEmailTypeModalProps {
  show: boolean
  onHide: () => void
  emailType: EmailType
}
export const UninstallEmailTypeModal: React.FC<UninstallEmailTypeModalProps> = ({ show, onHide, emailType }) => {
  const accountId = useAppSelector(selectAccountId)
  const [uninstallEmailType, { isSuccess, isLoading }] = useDeleteEmailTypeMutation()
  const handleDeleteEmailType = () => {
    uninstallEmailType({ accountId, emailTypeId: emailType.id })
  }

  useEffect(() => {
    if (isSuccess) {
      onHide()
    }
  }, [isSuccess, onHide])

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Email Type</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete email type <b>{emailType.name}</b> ?
          </div>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeleteEmailType}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
